<template>
  <v-card>
    <v-card-title>
     Students By Class
    </v-card-title>
    <v-tabs v-model="activeTab">
      <v-tab v-for='(grade, index) in gradesNew' :key="`tab-${index}`">{{grade.label}}</v-tab>
      <v-tab-item v-for='(grade, index) in gradesNew' :key="`tab-item-${index}`">
        <v-card>
          <!-- <v-card-title>{{grade.label}}</v-card-title> -->
          <v-container fluid grid-list-md>
            <v-layout row wrap>
              <v-flex  v-for="(cls, teacher) in grade.classes" :key="teacher" xs12 sm6 md4 lg3>
                <v-card>
                  <v-card-title>{{teacher}}</v-card-title>
                  
                  <v-divider></v-divider>
                  <v-list dense>
                    <v-list-item v-for="student in cls.students" :key="student.first + student.last">
                      <v-list-item-content>{{student.first}} {{student.last}}</v-list-item-content>
                      <v-list-item-content class="align-end">{{ student.home_phone }}</v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-card>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card>
      </v-tab-item>
    </v-tabs>
    <!-- <v-tabs-items v-model="activeTab"> -->
      
    <!-- </v-tabs-items> -->
  </v-card>
</template>

<script>
import firebase from 'firebase';

export default {
  name: 'StudentsByClass',
  data () {
    return {
      activeTab: 0,
      gradesNew: [
      ]
    }
  },
  props: {
    
  },
  mounted: function() {
    console.log('[studentsByClass][mounted]');
    firebase.firestore().collection('students').orderBy('grade').orderBy('teacher').orderBy('last').orderBy('first').get().then((snapshot) => {
      let grades =  {
        'K': {id:'K',label:'Kindergarten', classes: {}},
        '1': {id:'1',label:'1st Grade', classes: {}},
        '2': {id:'2',label:'2nd Grade', classes: {}},
        '3': {id:'3',label:'3rd Grade', classes: {}},
        '4': {id:'4',label:'4th Grade', classes: {}},
        '5': {id:'5',label:'5th Grade', classes: {}}
      };
      snapshot.forEach((doc) => {
        //console.log(doc.data());
        let student = doc.data();
        if(student.grade && student.grade.length > 0) {
          let cls = grades[student.grade].classes[student.teacher];
          if(!cls) grades[student.grade].classes[student.teacher] = {};
          let classStudents = grades[student.grade].classes[student.teacher]['students'];
          if(!classStudents) {
            grades[student.grade].classes[student.teacher]['students'] = [];
          }
          grades[student.grade].classes[student.teacher]['students'].push(student);
        }

      });
      this.gradesNew.push(grades['K']);
      this.gradesNew.push(grades['1']);
      this.gradesNew.push(grades['2']);
      this.gradesNew.push(grades['3']);
      this.gradesNew.push(grades['4']);
      this.gradesNew.push(grades['5']);


    });
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="stylus">

</style>
